module.exports = __webpack_public_path__ + "static/media/refresh.31b53eef.svg";